import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
//import 'rxjs/Rx';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthorizationService {
  constructor(public http: Http) {}

  postDate(payload: any) {
    console.log(payload);
    const body = JSON.stringify(payload);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http
      .post(
        'https://bilirubin-cdshooks.hspconsortium.org/cds-services/bilirubin-cds-hook',
        body,
        {
          headers: headers
        }
      )

      .pipe(
        tap(res => {
          return res;
        })
        // catchError(this.handleError('getAllExtractionDetails', []))
      );
  }
}
